import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";

import GameMatchImage from "./game/match-image/matchImage.game";
import GameMaze from "./game/maze/maze.game";
import GameCrossWord from "./game/cross-word/crossWord.game";
import GameScrambleWord from "./game/scramble-word/scrambleWord.game";
import GameHangman from "./game/hangman/hangman.game";
import SampleCanvas from "./game/sample-canvas/sampleCanvas";
import GameSearchWord from "./game/search-word/search.game";
import Home from "./pages/home/home";
import ListGame from "./pages/listGame";
import Campaign from "./pages/campaign/campaign";
import HomeLB from "./pages/home/home-lb";
import HomeLB2 from "./pages/home/home-lb-2";
import HomeLbUser from "./pages/home/home-lb-user";
import HomeLBAll from "./pages/home/home-lb-all";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* <Route path="/leaderboard-round1" element={<HomeLB />} />
      <Route path="/leaderboard-round2" element={<HomeLB2 />} /> */}

      <Route path="/leaderboard" element={<HomeLBAll />} />
    </Routes>
  );
}

export default App;
